import {AxiosInstance} from 'axios';

const SESSION_STORAGE_KEY = 'resware-session-id';
const SESSION_ID_HEADER = 'X-Resware-AI-Session-Id';

function getOrCreateSessionId(): string {
  let sessionId = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
  }
  return sessionId;
}

export function addSessionIdInterceptor(instance: AxiosInstance): void {
  instance.interceptors.request.use(config => {
    config.headers[SESSION_ID_HEADER] = getOrCreateSessionId();
    return config;
  });
}
